import type { LexicalCommand } from 'lexical'
import { createCommand } from 'lexical'
import type { LinkAttributes } from './types'

export const TOGGLE_LINK_COMMAND: LexicalCommand<
    string | ({ url: string } & LinkAttributes) | null
> = createCommand('TOGGLE_LINK_COMMAND')
